<template>
    <div class="imagetexts">
        <!-- <div class="tableTop"> -->
        <header>
            <el-form class="headerForm bodyForm" :model="searchLS">
                <el-row type="flex">
                    <el-form-item>
                        <el-input
                            clearable
                            size="medium"
                            placeholder="姓名 / 手机号"
                            v-model.trim="searchLS.key"
                            class="input-with-select"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select
                            size="medium"
                            v-model="searchLS.channel"
                            placeholder="请选择线索来源"
                            clearable
                        >
                            <el-option
                                v-for="item in clueChannel"
                                :key="item.value"
                                :label="item.key"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select
                            size="medium"
                            v-model="searchLS.status"
                            placeholder="请选择状态"
                            clearable
                        >
                            <el-option
                                v-for="item in $const.statusLS"
                                :key="item.value"
                                :label="item.key"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <div style="transform: translateY(5px)">
                        <el-button
                            type="primary"
                            @click="getClientList(true)"
                            size="small"
                            >搜索</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            @click="
                                () => {
                                    this.keys++
                                    this.leftDialog = true
                                }
                            "
                            >导入</el-button
                        >
                    </div>
                </el-row>
            </el-form>
        </header>

        <section>
            <el-table
                :data="tabList"
                border
                stripe
                ref="tableRef"
                v-loading="isLoading"
                row-key="id"
                @select="select"
                @select-all="select_all"
            >
                <el-table-column
                    width="55"
                    type="selection"
                    align="center"
                    :reserve-selection="true"
                    :selectable="selectable"
                ></el-table-column>
                <el-table-column
                    prop="id"
                    label="id"
                    v-if="false"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="username"
                    label="姓名"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="phone"
                    label="手机号"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="last_clue_source"
                    label="近期线索来源"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="last_clue_channel"
                    label="近期线索渠道"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="create_time"
                    label="首次记录时间"
                ></el-table-column>
                <el-table-column
                    align="center"
                    prop="last_create_time"
                    label="近期记录时间"
                ></el-table-column>
                <el-table-column align="center" label="操作" width="300px">
                    <div slot-scope="scope" class="operation">
                        <div class="view" @click="more(scope.row.id)">
                            更多线索来源
                        </div>
                    </div>
                </el-table-column>
            </el-table>

            <div class="ruleBt">
                <el-button
                    type="primary"
                    size="small"
                    v-show="allocation_rule == 2 ? false : true"
                    @click="
                        () => {
                            if (checkList.length) bottomDialog = true
                            else this.$commonFun.toast('请选择线索', 'warning')
                        }
                    "
                    >分配</el-button
                >
                <el-button
                    v-if="is_leader == 1 ? true : false"
                    type="primary"
                    size="small"
                    @click="
                        () => {
                            if (checkList.length) bottomDialog1 = true
                            else this.$commonFun.toast('请选择线索', 'warning')
                        }
                    "
                    >可见</el-button
                >
                <el-button type="danger" size="small" @click="delHandler"
                    >删除</el-button
                >
            </div>
            <!-- 分页 -->
            <div class="tablePage">
                <el-pagination
                    hide-on-single-page
                    background
                    @size-change="sizePage"
                    :current-page.sync="search.page"
                    :page-size="search.limit"
                    :total="search.total"
                    :page-sizes="[15, 20, 25]"
                    layout="total, sizes, prev, pager, next"
                ></el-pagination>
            </div>
            <!-- 线索来源-->
            <el-drawer
                title="线索来源"
                :visible.sync="rightDialog"
                direction="rtl"
                size="1000px"
            >
                <div class="drawerBox">
                    <el-table
                        :data="rtRequestData"
                        border
                        stripe
                        v-loading="isLoading1"
                    >
                        <el-table-column
                            align="center"
                            type="index"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="id"
                            label="id"
                            v-if="false"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="clue_id"
                            label="clue_id"
                            v-if="false"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="source"
                            label="来源项目"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="channel"
                            label="来源渠道"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="create_time"
                            label="来源时间"
                        ></el-table-column>
                    </el-table>
                </div>
            </el-drawer>
            <!-- 批量导入线索 -->
            <el-dialog
                title="批量导入线索"
                custom-class="listDialog"
                width="600px"
                style="padding-bottom:30px"
                :visible.sync="leftDialog"
                @close="
                    () => {
                        $refs.rightTabForm.resetFields()
                        $refs.selectStaffRef.init()
                    }
                "
            >
                <el-form
                    :model="rightRequestList"
                    ref="rightTabForm"
                    label-width="100px"
                >
                    <el-form-item
                        label="上传文件"
                        prop="file"
                        :rules="[{ required: true, message: '请上文件' }]"
                    >
                        <el-input v-show="false"></el-input>
                        <threadFileUpload
                            :key="keys"
                            ref="fileUploadRef"
                            mediaType="excel"
                            :staff_divide="rightRequestList.staff_divide"
                            :staff_visible="rightRequestList.staff_visible"
                        ></threadFileUpload>
                        <div class="desc">
                            只能上传xlsx/xlx文件,且不超过5M,过大可能导致上传失败
                        </div>
                        <div class="onLoad" @click="onLondEvent">下载模板</div>
                    </el-form-item>
                    <el-form-item label="分配" prop="on_show">
                        <el-radio
                            v-model="rightRequestList.on_show"
                            v-for="(item, index) in $const.statusStaff"
                            :key="index"
                            :label="item.value"
                            >{{ item.key }}</el-radio
                        >
                    </el-form-item>
                    <el-form-item
                        label=""
                        v-show="rightRequestList.on_show == 1"
                    >
                        <selectStaff
                            ref="selectStaffRef"
                            @staffCollBack="
                                rightRequestList.staff_divide = $event
                            "
                        >
                        </selectStaff>
                    </el-form-item>
                    <el-form-item label="可见" prop="on_show1">
                        <el-radio
                            v-model="rightRequestList.on_show1"
                            v-for="(item, index) in $const.statusStaff"
                            :key="index"
                            :label="item.value"
                            >{{ item.key }}</el-radio
                        >
                    </el-form-item>
                    <el-form-item
                        label=""
                        v-show="rightRequestList.on_show1 == 1"
                    >
                        <selectStaff
                            @staffCollBack="
                                rightRequestList.staff_visible = $event
                            "
                        >
                        </selectStaff>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        type="primary"
                        size="small"
                        @click="excelInCustomer"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog
                :title="title"
                custom-class="listDialog"
                width="500px"
                style="padding-bottom:30px"
                :visible.sync="bottomDialog"
                @close="close"
            >
                <Dialog
                    :staff="staff"
                    @checkRadio="checkRadio"
                    ref="DialogRef"
                ></Dialog>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="ruleSubmit()"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
            <el-dialog
                title="可见"
                custom-class="listDialog"
                width="500px"
                style="padding-bottom:30px"
                :visible.sync="bottomDialog1"
                @close="$refs.selectStaffRef.init()"
            >
                <selectStaff
                    @staffCollBack="staff_id = $event"
                    ref="selectStaffRef"
                >
                </selectStaff>
                <div slot="footer" class="dialog-footer">
                    <el-button
                        type="primary"
                        size="small"
                        @click="ruleSubmit1()"
                        >确 定</el-button
                    >
                </div>
            </el-dialog>
        </section>
    </div>
</template>

<script>
import Dialog from '@/components/clients/dialog.vue'
import fileUpload from '@/components/fileUpload/index.vue'
import threadFileUpload from '@/components/clients/threadFileUpload.vue'
import selectStaff from '@/components/selectStaff'
export default {
    components: { Dialog, fileUpload, selectStaff, threadFileUpload },
    data() {
        return {
            keys: 0,
            bottomDialog1: false,
            rightRequestList: {
                file: {},
                on_show: 2,
                on_show1: 2,
                staff_divide: [], //分配给谁
                staff_visible: [], //谁可见
            },
            checkList: [],
            bottomDialog: false,
            title: '分配线索',
            allocation_rule: '', //分配规则
            staff: [],
            clueChannel: [],
            searchLS: {},
            fileInfor: {},
            data: {},
            leftDialog: false,
            rtRequestData: [],
            rightDialog: false,
            isLoading: false,
            isLoading1: false,
            search: {
                total: 0,
                page: 1,
                limit: 15,
            },
            tabList: [],
            flag: 0,
            val: '',
            staff_id: [],
            is_leader: '',
        }
    },
    async mounted() {
        this.is_leader = this.$store.state.app.myStoreCur.is_leader
        let dynamicConfig = await this.$store.dispatch('dynamicConfig')
        this.allocation_rule = dynamicConfig.allocation_rule
        this.staff = dynamicConfig.staff
        this.clueChannel = this.$store.state.app.globalConfig.clueChannel
        this.getClientList()
    },
    watch: {
        'search.page'() {
            this.getClientList()
        },
        'search.limit'() {
            this.getClientList()
        },
    },

    methods: {
        // 批量导入
        async excelInCustomer() {
            if (!Object.keys(this.$refs.fileUploadRef.filePath).length) {
                this.$commonFun.toast('请上传文件', 'error')
                return
            }
            await this.$refs.fileUploadRef.httpRequest()
            this.$commonFun.toast('导入成功', 'success')
            this.$refs.fileUploadRef.init()
            this.$nextTick(() => {
                this.leftDialog = false
            })
        },
        delHandler() {
            if (!this.checkList.length)
                return this.$commonFun.toast('请选择线索', 'warning')

            this.$confirm('确定删除该线索？此操作不可逆！', '提示').then(
                async () => {
                    const res = await this.$api.clueDel({ ids: this.checkList })
                    this.$commonFun.toast('删除成功', 'success')
                    this.$refs.tableRef.clearSelection()
                    this.checkList = []
                    this.flag = 0
                    this.getClientList(true)
                }
            )
        },
        // selection_change(val) {
        //     let check = this.tabList.filter((item) => item.status == 2)
        //     if (val.length == check.length) {
        //         this.$nextTick(() => {
        //             this.flag = 1
        //         })
        //     }
        //     if (val.length == 0 || val.length < check.length) {
        //         this.$nextTick(() => {
        //             this.flag = 0
        //         })
        //     }
        // },
        select_all(val) {
            this.checkList = val.map((v) => v.id)
            // if (this.flag) {
            //     this.checkList = []
            //     this.flag = 0
            //     return
            // }
            // this.flag++
            // let checkAll = val.map((res) => res.id)
            // if (!this.checkList.length) {
            //     this.checkList.push(...checkAll)
            //     return
            // }
            // checkAll.forEach((row) => {
            //     let index = this.checkList.findIndex(
            //         (element) => element == row
            //     )
            //     if (index == -1) this.checkList.push(row)
            // })
        },
        select(val, item) {
            this.checkList = val.map((v) => v.id)
            // if (this.checkList.indexOf(item.id) == -1) {
            //     this.checkList.push(item.id)
            // } else {
            //     let index = this.checkList.findIndex((res) => res == item.id)
            //     this.checkList.splice(index, 1)
            // }
        },
        selectable(row) {
            if (row.status == 1) return false
            if (row.status == 2) return true
        },
        // 组件关闭
        close() {
            this.$refs.DialogRef.init()
        },
        checkRadio(val) {
            this.val = val
        },
        async ruleSubmit(isrefash) {
            if (isrefash) {
                if (!this.staff_id.length)
                    return this.$commonFun.toast('请选择经纪人', 'warning')
                this.bottomDialog1 = false
                let params = { staff: this.staff_id, ids: this.checkList }
                const res = await this.$api.clueVisible(params)
            } else {
                if (!this.val)
                    return this.$commonFun.toast('请选择经纪人', 'warning')
                this.bottomDialog = false
                let params = {
                    staff_id: this.val,
                    clue_id: this.checkList,
                }
                const res = await this.$api.clueDistributions(params)
            }
            this.$commonFun.toast('SUCCESS', 'success')
            this.$refs.tableRef.clearSelection()
            this.checkList = []
            this.flag = 0
            this.getClientList()
        },
        ruleSubmit1() {
            this.ruleSubmit(true)
        },

        // 下载模板
        onLondEvent() {
            let url = this.$config.request_url
            let hrefs = this.$store.state.app.globalConfig.excelTemplate
                .customer_template.value
            window.open(url + hrefs)
        },
        sizePage(val) {
            this.search.limit = val
        },

        //抽屉
        async more(id) {
            this.rightDialog = true
            this.isLoading1 = true
            let param = {
                clue_id: id,
            }
            const res = await this.$api.clueOrigin(param)
            this.rtRequestData = res
            this.isLoading1 = false
        },
        async getClientList(refash) {
            if (refash) {
                this.search.page = 1
                if (Object.keys(this.searchLS).length) {
                    this.$refs.tableRef.clearSelection()
                }
            }
            this.isLoading = true
            let param = {
                ...this.search,
                ...this.searchLS,
            }
            const res = await this.$api.clueList(param)
            this.tabList = res.data
            this.search.total = res.count
            this.isLoading = false
        },
    },
}
</script>

<style lang="scss">
.desc {
    font-size: 12px;
    margin-top: 5px;
    line-height: 16px !important;
    color: #ccc;
}
.onLoad {
    margin-top: 5px;
    line-height: 16px !important;
    font-size: 12px;
    color: red;
    cursor: pointer;
}
</style>
